<div class="header">
  <div class="header-left">
    <div class="h-col">
      <ng-container *ngIf="branchLoaded && branchName">{{ branchName }} ({{ branchId }})</ng-container>
    </div>
    <div id="subheader-created-date" class="h-col">
      Created:
      <span *ngIf="branchLoaded">{{
        ((data$ | async)?.instanceMetadata?.dates?.created?.split('T')[0] | date: 'MM/dd/yyyy') ?? '-'
      }}</span>
    </div>
    <div id="subheader-saved-date" class="h-col">
      Last Saved:
      <span *ngIf="branchLoaded">{{ ((data$ | async)?.modifiedOn?.split('T')[0] | date: 'MM/dd/yyyy') ?? '-' }}</span>
    </div>
  </div>
  <div class="header-right">
    <ng-container *ngIf="data$ | async as data">
      <div class="h-col h-btns">
        <finra-button
          *ngIf="(displayRules$ | async)?.canRecall && !isUnsubmitted"
          theme="tertiary"
          tabindex="0"
          (click)="recallForm()"
          [disabled]="!isCurrentVersion"
          aria-label="Recall filing"
        >
          <finra-icon icon="Sync" family="regular" size="xs" class="action-icon">Recall</finra-icon>
        </finra-button>
        <finra-button
          *ngIf="(displayRules$ | async)?.canDelete"
          aria-label="Delete MU3"
          theme="tertiary"
          tabindex="0"
          (click)="deleteForm()"
          [disabled]="!isCurrentVersion"
        >
          <finra-icon icon="TrashAlt" family="light" size="xs" class="action-icon">Delete</finra-icon>
        </finra-button>
      </div>
      <div *ngIf="(displayRules$ | async)?.isShowDisplayStatus" class="h-col h-status">
        <finra-chip
          id="subheader-status-chip"
          class="pointer"
          [theme]="'white'"
          [text]="(displayRules$ | async)?.displayedStatus"
        >
        </finra-chip>
      </div>
      <div *ngIf="!isFormView && !isFilingProcessed" class="h-col h-btns">
        <finra-button
          *ngIf="canViewInvoice"
          [attr.aria-label]="'Total Fees ' + (!totalCharges ? '$0.00' : totalCharges)"
          class="flex-row gap-1"
          [disabled]="!totalCharges"
          theme="tertiary"
          tabindex="0"
          (click)="openInvoice()"
        >
          <strong style="text-decoration: underline">Fees: {{ !totalCharges ? '$0.00' : totalCharges }}</strong>
        </finra-button>
      </div>
    </ng-container>
  </div>
</div>
